import { Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import SEO from '../src/components/SEO';
import Search from '../src/components/Search';
import NavBar from '../src/components/NavBar';
import {
  selectFirebaseAuthed,
  selectFirebaseAuthIsLoaded,
} from '../src/selectors';

function SearchPage(props: any) {
  const router = useRouter();

  // SEO
  const metaTitle = `PTTBrain | 搜尋 - ${router.query.q as string}`;
  const metaDescription = `PTTBrain 全站搜尋 ${(router.query
    .platform as string)?.toUpperCase()} 內關鍵字: ${router.query.q as string}`;

  const { authIsLoaded, authed } = props;

  return (
    <>
      <SEO title={metaTitle} description={metaDescription} />
      <NavBar>
        {!authIsLoaded ? (
          <Loader active inline="centered" />
        ) : (
          // @ts-ignore
          <Search authed={authed} />
        )}
      </NavBar>
    </>
  );
}

const mapStateToProps = (state: any) => ({
  authIsLoaded: selectFirebaseAuthIsLoaded(state),
  authed: selectFirebaseAuthed(state),
});

export default connect(mapStateToProps)(SearchPage);
